import { useTranslation } from 'react-i18next'

import { useDateLimits, useScreen } from '../../../../../hooks'
import { DatePicker } from '../../../../DateTime'
import { FormikField } from '../../../../Formik'

function ContractStartDateField(props) {
  const { t } = useTranslation()
  const { maxDate, minDate } = useDateLimits()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...props}
      Component={DatePicker}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Flat.StartDateLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      maxValue={maxDate}
      minValue={minDate}
      placeholder={t('Flat.StartDatePlaceholderKey')}
    />
  )
}

export default ContractStartDateField
